import { render, staticRenderFns } from "./pretest.vue?vue&type=template&id=07f12a6f&scoped=true"
import script from "./pretest.vue?vue&type=script&lang=js"
export * from "./pretest.vue?vue&type=script&lang=js"
import style0 from "./pretest.vue?vue&type=style&index=0&id=07f12a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f12a6f",
  null
  
)

export default component.exports